import { Loader } from './Loader';

export function LazyLoader() {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <Loader size="large" />
    </div>
  );
}
